import { Component } from '@angular/core';

@Component({
	standalone: true,
	selector: 'app-table-header',
	templateUrl: 'table-header.component.html',
	styleUrls: ['table-header.component.scss']
})
export class TableHeaderComponent {}
